import { render, staticRenderFns } from "./dict-add.vue?vue&type=template&id=677cd628&scoped=true&"
import script from "./dict-add.vue?vue&type=script&lang=js&"
export * from "./dict-add.vue?vue&type=script&lang=js&"
import style0 from "./dict-add.vue?vue&type=style&index=0&id=677cd628&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=677cd628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677cd628",
  null
  
)

component.options.__file = "dict-add.vue"
export default component.exports